import { generateAccessTokenLintraAPI } from "../services/lentraService";

let userGestureActive = false;

export function markUserGestureStart() {
  userGestureActive = true;
}

export function consumeUserGesture() {
  return userGestureActive;
}

// 🔹 new helper
export function resetUserGesture() {
  userGestureActive = false;
}
// Delay
export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const lentraRedirect = async () => {
  try {
    const res = await generateAccessTokenLintraAPI();

    const token = res?.oBody?.payLoad?.oauthToken?.access_token;
    const institutionId = res?.oBody?.payLoad?.oauthToken?.institutionId;
    localStorage.setItem("lentra_access_token", token);
    localStorage.setItem("lentra_institutionId", institutionId);

    setTimeout(() => {
      if (token) {
        if (window.parent) {
       window.parent.location.href = `/onboarding-redirect`;
        }else { 
        window.location.href = `/onboarding-redirect`;
        }
      }
    }, 0);
  } catch (error) {
    window.location.href = `/lentra-error`;
    console.log("Lentra access token error:", error);
  }
};